import { render, staticRenderFns } from "./tagDialog.vue?vue&type=template&id=61180fb7&scoped=true"
import script from "./tagDialog.vue?vue&type=script&lang=js"
export * from "./tagDialog.vue?vue&type=script&lang=js"
import style0 from "./tagDialog.vue?vue&type=style&index=0&id=61180fb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61180fb7",
  null
  
)

export default component.exports